import { Component } from '@angular/core';

@Component({
  selector: 'login-logo',
  styleUrls: ['./login-logo.less'],
  templateUrl: './login-logo.html',
  inputs: ['shakeLogo']
})
export class LoginLogoComponent {
  shakeLogo: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/login/login-logo/login-logo.component.ts